<template>
  <div>
    <DeleteProductModal
      :product-id="serviceId"
      :deleting="deleting"
      v-on="{ submit: handleProductDelete }"
    />
  </div>
</template>

<script>
import { productMethods } from '@/store/adminHelper';
import DeleteProductModal from '@/components/Products/DeleteProductModal.vue';

export default {
  name: 'BasicProductDestroy',
  components: {
    DeleteProductModal,
  },
  props: {
    serviceId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    deleting: false,
  }),
  methods: {
    ...productMethods,
    handleProductDelete(serviceId) {
      this.deleting = true;
      this.deleteProduct({ productId: serviceId })
        .then(() => {
          this.deleting = false;
          this.redirectToServiceList();
        })
        .catch(() => {
          this.deleting = false;
        });
    },
    redirectToServiceList() {
      this.$router.replace({ name: 'admin.products.services' });
    },
  },
};
</script>
